{
  "landmark-nieuwe-kerk": 2767.6,
  "landmark-oude-kerk": 2406.4,
  "landmark-oude-stadhuis": 2842.4
}
